module.exports = __webpack_public_path__ + "static/img/default_image_small.79438c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/default_image_small.png
// module id = JWrO
// module chunks = 11